import React from 'react'
import './Entire_Details.css'
function Entire_Details({ Part_details, toggleDiv }) {



  return (
    <div>
      <div className='overlay'>
        <div className='dashboard-container'>
          <div className="dashboard-header">
            <h2>Part Lifecycle Tracker</h2>
            <button className="close-btn" onClick={toggleDiv}>×</button>
          </div>

          <div className="dashboard-grid">
            {/* Left Section - PO Details */}
            <div className="dashboard-card">
              <h3>Purchase Order Details</h3>
              <div className="detail-group">
                <label>PO Number:</label>
                <div className="detail-value">{Part_details[0]?.PO_PartNo}</div>
              </div>
              <div className="detail-group">
                <label>PO Date:</label>
                <div className="detail-value">{new Date(Part_details[0]?.PO_DATE).toLocaleDateString()}</div>
              </div>
              <div className="detail-group">
                <label>Order Qty:</label>
                <div className="detail-value highlight">{Part_details[0]?.PO_Qty}</div>
              </div>
              <div className="detail-group">
                <label>Part Name:</label>
                <div className="detail-value part-name">{Part_details[0]?.Part_Name}</div>
              </div>
            </div>

            {/* Middle Section - Production Details */}
            <div className="dashboard-card">
              <h3>Production Timeline</h3>
              <div className="timeline">
                <div className="timeline-event">
                  <div className="event-label">Cut Date:</div>
                  <div className="event-value">{Part_details[0]?.Cut_Date?.slice(0, 10)}</div>
                  <div className="event-meta">by {Part_details[0]?.Cutting_Operator}</div>
                </div>

                <div className="timeline-event">
                  <div className="event-label">Finishing Start:</div>
                  <div className="event-value">{Part_details[0]?.Finishing_Start_Date?.slice(0, 10)}</div>
                  <div className="event-meta">by {Part_details[0]?.Finishing_operator}</div>
                </div>

                <div className="timeline-event">
                  <div className="event-label">Issued On:</div>
                  <div className="event-value">{Part_details[0]?.Issue_Date?.slice(0, 10)}</div>
                  <div className="event-meta">Qty: {Part_details[0]?.Issued_QTY}</div>
                </div>
              </div>
            </div>

            {/* Right Section - Shipping & Tracking */}
            <div className="dashboard-card">
              <h3>Shipping & Tracking</h3>
              <div className="detail-group">
                <label>Shipped Date:</label>
                <div className="detail-value">{Part_details[0]?.ACTUAL_SHIP_DATE?.slice(0, 10)}</div>
              </div>
              <div className="detail-group">
                <label>Qty Shipped:</label>
                <div className="detail-value highlight">{Part_details[0]?.QTY_SHIPPED}</div>
              </div>
              <div className="detail-group">
                <label>Sheet ID:</label>
                <div className="detail-value tracking-id">{Part_details[0]?.Sheet_Id}</div>
              </div>
              <div className="detail-group">
                <label>Lot Number:</label>
                <div className="detail-value tracking-id">{Part_details[0]?.Issued_LotNo}</div>
              </div>
              <div className="detail-group">
                <label>Supervisor:</label>
                <div className="detail-value">{Part_details[0]?.Issuing_Supervisor}</div>
              </div>
            </div>
          </div>

          <div className="action-bar">
            <button className="pdf-button" >
              Export to PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Entire_Details